// extracted by mini-css-extract-plugin
export default {"detailsContainer":"style_detailsContainer__Q6jz2"};